import React from 'react';

/*
 * Isolates assistant render errors so a malformed message can't take down the
 * whole app. Renders a minimal fallback in place of the panel body.
 */
interface State {
  error: Error | null;
}

class AssistantErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[Assistant] render error', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 20, fontSize: 13, color: '#a8071a' }}>
          <div style={{ marginBottom: 10 }}>
            Something went wrong displaying the assistant.
          </div>
          <button
            type="button"
            className="bra-btn bra-retry"
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AssistantErrorBoundary;
